class CoursesService {
    constructor(YiiModel) {
        this.YiiModel = YiiModel;
        this.all = YiiModel.all('courses');
        this.one = (id) => {
            return YiiModel.one('courses').$find(id);
        };
    }
}

export {
    CoursesService
};
